import React, { FC } from 'react';

import { TectonDateTimeFormat } from '../../../components/@tecton/ComponentRedesign/utils';
import moment from 'moment-timezone';
import { ApplyLogTableDataRow } from './ApplyLogTypes';
import UpdateLogEntry from '../../../service/UpdateLogEntry';
import { Avatar, ExtendedTableColumn, Table, Link, FlexItem, FlexGroup } from '@lithos';

export interface ApplyLogItem {
  commit_id: string;
  appliedBy: string;
  applyTimestamp: Date;
  sdkVersion: string;
}

interface ApplyLogTableProps {
  items: ApplyLogItem[];
}

const ApplyLogTable: FC<ApplyLogTableProps> = ({ items }) => {
  const parseUpdateLogData = (data: unknown[]) => {
    const results: ApplyLogTableDataRow[] = data.map((e) => {
      const entry = e as UpdateLogEntry;

      return {
        applyId: entry.applyId,
        user: entry.owner,
        date: entry.appliedAt,
        link: `./${entry.applyId}`,
        sdkVersion: entry.sdkVersion,
      };
    });

    return results;
  };

  const applyLogColumns: ExtendedTableColumn<ApplyLogTableDataRow & { id: string }>[] = [
    {
      name: 'Commit ID',
      id: 'commitId',
      content: (item: ApplyLogTableDataRow) => {
        return <Link url={item.link} name={item.applyId} />;
      },
    },
    {
      name: 'Applied By',
      id: 'appliedBy',
      content: (item: ApplyLogTableDataRow) => (
        <FlexGroup padding="0">
          <FlexItem grow={0}>
            <Avatar name={item.user} />
          </FlexItem>
          <FlexItem grow={0}>{item.user}</FlexItem>
        </FlexGroup>
      ),
    },
    {
      name: 'Apply Time',
      id: 'applyTime',
      content: (item: ApplyLogTableDataRow) => TectonDateTimeFormat(moment(item.date)),
    },
    {
      name: 'SDK Version',
      id: 'sdkVersion',
      content: (item: ApplyLogTableDataRow) => item.sdkVersion,
    },
  ];

  return (
    <Table items={parseUpdateLogData(items).map((item) => ({ ...item, id: item.applyId }))} columns={applyLogColumns} />
  );
};

export default ApplyLogTable;
